import "./style.css";
import { useState, useEffect } from "react";
import stars_image from "assets/icons/star_img.svg";
import heartwhite from "assets/icons/heartwhite.svg";
import { NavLink, useNavigate } from "react-router-dom";
import { gql, useMutation, useQuery } from "@apollo/client";
import Loader from "components/Spinners/Loader";
import Button from "components/Buttons";

import { LIST_SADDLE_FAVORITES } from "apollo/queries/saddleFavorite";
import { DELETE_SADDLE_FAVORITE } from "apollo/mutations/saddleFavorite";
import { listUserHorses } from "apollo/queries/horses";
import { getCurrentUser } from "aws-amplify/auth";
import { useCartStore } from "stores/cart/useCartStore";
import ModalStore from "components/Modal/ModalStore";
import CactusSaddleIcon from "assets/icons/cactus_saddleIcon.svg?react";
import CactusSaddleryLogo from "assets/icons/cactus_saddlery_logo.svg?react";
import Gauge from "components/Guage/Guage";
import SeatSizeIcon from "assets/icons/seat-size.svg?react";
import ShoppingCartModal from "components/Modal/ShoppingCart";
import SelectHorseScore from "assets/icons/select_horse_score.svg?react";
import { useModalStore } from "stores/modal/useModalStore";
import { useBrandDisciplineStore } from "stores/brandDiscipline/useBrandDisciplineStore";
import { useAuthStore } from "stores/auth/authStore";

const Favorite = () => {
  const user = useAuthStore((state) => state.user);
  const actionState = useBrandDisciplineStore((state => state.actionState));
  const changeActionState = useBrandDisciplineStore((action => action.changeActionState));
  const open = useModalStore((s) => s.open);
  const handleAddToCart = useCartStore((action) => action.handleAddToCart);
  const addToCartLoading = useCartStore((state) => state.loadingState?.addToCartLoading);
  const userCartData = useCartStore((s) => s.userCartData);
  const handleRemove = useCartStore((s) => s.handleRemove);
  const removeCartLoading = useCartStore((s) => s.loadingState?.removeCartLoading);
  const loadingItemId = useCartStore((s) => s.loadingItemId);

  const [size] = useState({
    width: "200px",
    height: "90px",
  });

  const [selectedHorseStatus, setHorseStatus] = useState(null);
  const [selectedHorse, setSelectedHorse] = useState(null);
  const [loadingToggle, setLoadingToggle] = useState({});
  const { loading, data } = useQuery(gql(LIST_SADDLE_FAVORITES), {
    fetchPolicy: "network-only"
  });
  const navigate = useNavigate();

  const {
    loading: listLoading,
    data: listUserHorsesData,
    refetch: refetchListUserHorses,
  } = useQuery(gql(listUserHorses), { skip: !user });

  const [deleteSaddleFavourite] = useMutation(gql(DELETE_SADDLE_FAVORITE));

  useEffect(() => {
    const fetchListUserHorsesData = async () => {
      try {
        const { username } = await getCurrentUser();
        if (username) {
          await refetchListUserHorses();
        }
      } catch (error) {
        console.error("Error fetching user horses:", error);
      }
    };

    fetchListUserHorsesData();
    // Fetch once on mount only.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const ByHorseFilterOption = listUserHorsesData?.listUserHorses?.items.map(
      (item) => ({
        value: item?.id,
        label: item?.name,
      })
    );
    if (
      Array?.isArray(ByHorseFilterOption) &&
      ByHorseFilterOption?.length > 0
    ) {
      const selectedHorseData = listUserHorsesData?.listUserHorses?.items?.find(
        (item) => item?.status
      );
      setHorseStatus(selectedHorseData?.status)
      setSelectedHorse(ByHorseFilterOption[0]);
    }
  }, [listUserHorsesData]);

  const toggle = async (id) => {
    if (id) {
      setLoadingToggle((prevState) => ({
        ...prevState,
        [id]: true,
      }));
      try {
        await deleteSaddleFavourite({
          variables: { saddleId: id },
          refetchQueries: ['listSaddleFavorites'],
        });
        setLoadingToggle((prevState) => ({
          ...prevState,
          [id]: false,
        }));
      } catch (error) {
        setLoadingToggle((prevState) => ({
          ...prevState,
          [id]: false,
        }));
        ModalStore.openSimpleError({
          icon: undefined,
          title: "Error",
          subtitle: error?.message,
          shouldCloseOnOverlayClick: false,
        });
      }
    }
  };

  const generateSeoUrl = (item) => {
    const slug = item?.productTitle?.replace(/\s+/g, "-").toLowerCase();
    const year = new Date(item?.createdAt).getFullYear();
    return `/saddle/${slug}-${year}`;
  };

  const handleDetails = (item, i) => {
    document.documentElement.style.scrollBehavior = "none";

    window.scrollTo(0, 0);
    navigate(generateSeoUrl(item), {
      state: { item, index: i, selectedHorse },
    });

    setTimeout(() => {
      document.documentElement.style.scrollBehavior = "";
    }, 0);
  };

  return (
    <div className="my-[120px]">
      <div className="w-[310px] sm:w-[40%] lg:w-[90%] xl:max-w-[1300px]  mx-auto flex flex-wrap gap-[40px]  items-center justify-between ">
        <div className="w-[383px]  md:w-[583px]  h-auto flex flex-col items-center lg:items-start">
          <img src={stars_image} alt="stars" />
          <h1 className="favorite-saddle__title text-center lg:text-start">Your favorite Saddles</h1>
          <p className="favorite-text">
            You’re getting closer to finding the Best Fit!
          </p>
          <p className="favorite-text_mobile">Find the Best Fit!</p>
        </div>
      </div>
      {loading || listLoading ? (
        <div className="flex justify-center items-center h-full w-full">
          <Loader
            filledColor="#2b364b"
            className="!h-[60px] !flex !items-center !text-center !justify-center"
          />
        </div>
      ) : (
        <div className={`cactus_card-container`}>
          <div className="flex flex-wrap justify-center w-auto md:w-[70%] lg:justify-normal items-center mx-auto lg:w-[90%] xl:max-w-[1300px] gap-[30px] py-10">
            {data?.listSaddleFavorites?.length > 0 ? (
              data?.listSaddleFavorites
                ?.slice()
                .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                .map((item, index) => (
                  <div
                    key={`saddle-card-${index}`}
                    className="saddle_cards_container"
                  >
                    <div className="flex gap-x-[16px] w-full">
                      {/* {index === 0 && (
                        <h1 className="cards_pill">Just Arrived</h1>
                      )} */}
                      <div className="w-full h-auto flex flex-col gap-y-2">
                        <div className="mt-2 flex flex-row gap-x-[41.24px] justify-between w-full  min-h-[67px]">
                          <div className="w-full flex flex-col">
                            <NavLink
                              to="/cactus"
                              className="text-[#5B7FB4] text-[14px] sm:text-[18px] font-semibold flex justify-between items-center leading-[110%] font-[Montserrat] cursor-pointer hover:underline"
                            >
                              {item?.saddle?.brandName
                                ?.toLowerCase()
                                ?.replace("cactussaddlery", "Cactus")}
                              <CactusSaddleIcon className="w-[20px] h-[20px] mr-[2px]" />
                            </NavLink>
                            <p className="font-[Montserrat] saddle_title min-h-[25px] font-[700] mt-[4px] overflow-hidden !text-[14px] sm:!text-[18px]">
                              {item?.saddle?.productTitle?.includes("Cactus")
                                ? item?.saddle?.productTitle
                                  ?.replace("Cactus", "")
                                  ?.trim()
                                : item?.saddle?.productTitle || "Rancher"}
                            </p>
                            <p className="font-[Montserrat] font-[700] text-[14px] mt-[8px] sm:!text-[18px]">
                              {`$${item?.saddle?.price
                                ?.toFixed(0)
                                ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") ?? 0
                                }`}
                            </p>
                          </div>
                          {item?.saddle?.size && (
                            <div className="flex flex-col items-center justify-center p-2 min-w-[73px] h-[48px] rounded-lg bg-[rgba(43,54,75,0.08)]">
                              <p className="item_size !text-[10px]">
                                SEAT SIZE:
                              </p>
                              <div className="flex flex-row items-center gap-[4.67px]">
                                <SeatSizeIcon />
                                <p className="item_size">{`${item?.saddle?.size}”`}</p>
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="flex gap-x-[16px] w-full">
                          <div className="relative h-[155px]">
                            <img
                              src={item?.saddle?.photo}
                              alt={item?.saddle?.photo ?? "cactus_saddle"}
                              className={`h-[155px] w-[173px] rounded-lg`}
                            />
                            <CactusSaddleryLogo className="w-[30px] h-[20px] sm:w-[50px] sm:h-[26px] absolute bottom-[7px] left-[6px]" />
                          </div>

                          {selectedHorseStatus === "LIVE" ? (
                            <div className="h-[155px] !min-w-[160px] sm:max-w-auto cactus_score_container">
                              <div className="cactus_saddlefit_score_text sm:block hidden !text-[14px]">
                                Your SaddleFit Score
                              </div>
                              <div className="cactus_saddlefit_score_text block sm:hidden !text-[12px]">
                                SaddleFit score
                              </div>
                              <div className="mt-[-20px]">
                                <Gauge
                                  style={{
                                    width: size.width,
                                    height: size.height,
                                    fontFamily: "Montserrat",
                                    fontWeight: "bold",
                                  }}
                                  score={Math.round(item?.score ?? 0)}
                                />
                              </div>
                            </div>
                          ) : (
                            <div className="cactus_score_container !w-[189px] sm:!w-[234px]">
                              <div className="cactus_saddlefit_score_text">
                                What’s Your Saddle Fit Score?
                              </div>
                              <SelectHorseScore
                                onClick={() => {}}
                                className="select_horse_score_img cursor-pointer"
                              />
                            </div>
                          )}
                        </div>
                        <div className="flex items-center gap-x-2 w-full">
                          <div
                            onClick={() => toggle(item?.saddle?.sk)}
                            className={`saddle_btn_heart cursor-pointer !bg-[#2B364B]`}
                          >
                            {loadingToggle && loadingToggle[item?.saddle?.sk] ? (
                              <Loader
                                filledColor="#2b364b"
                                loaderStyles="!w-5 !h-5 !flex !items-center !text-center !justify-center"
                              />
                            ) : (
                              <img
                                src={heartwhite}
                                alt="heart"
                                className="w-[24px] h-[24px]"
                              />
                            )}
                          </div>
                          {(() => {
                            const isInCart = userCartData?.items?.some(
                              (ci) => (ci?.productData?.sk || ci?.saddleId || ci?.id) === item?.saddle?.sk
                            );
                            const isAnyInCart = (userCartData?.items?.length || 0) > 0;
                            if (isInCart) {
                              return (
                                <Button
                                  loading={removeCartLoading && loadingItemId === item?.saddle?.sk}
                                  onClick={() => handleRemove(item?.saddle?.sk)}
                                  className="find_score_add_to_cart w-[41%] sm:max-w-[182.6178px] sm:w-full !bg-[#C8403B]"
                                >
                                  Remove From Cart
                                </Button>
                              );
                            }
                            return (
                              <Button
                                loading={addToCartLoading === item?.saddle?.sk}
                                className="find_score_add_to_cart w-[41%] sm:max-w-[182.6178px] sm:w-full disabled:!bg-[#A3A3A3] disabled:!text-white disabled:opacity-100"
                                disabled={addToCartLoading === item?.saddle?.sk || selectedHorseStatus === "PENDING" || (isAnyInCart && !isInCart)}
                                onClick={() => handleAddToCart(item?.saddle, selectedHorse, changeActionState, open, item?.score)}
                              >
                                Add to Cart
                              </Button>
                            );
                          })()}
                          <Button
                            onClick={() => {
                              handleDetails(item?.saddle, index);
                            }}
                            className="find_score_more_details w-[41%] sm:max-w-[182.6178px] sm:w-full"
                          >
                            More details
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
            ) : (<div className="no_favorite_card flex item items-center justify-center mx-auto capitalize w-full">
              No Favorites
            </div>)}
          </div>
        </div>
      )}

      {actionState?.adding !== undefined && (
        <ShoppingCartModal
          isAdding={actionState.adding}
          description={
            !actionState.adding &&
            "The Saddle is already in your shopping cart."
          }
        />
      )}
    </div >
  );
};

export default Favorite;
